import { gql } from "@apollo/client";
import { MilestoneInfo } from "./getMilestonesCall";
import { Def_MutationResponse } from "../../UserCalls/GQLCalls/userCalls";

export const MARK_MILESTONE_AS_DELETED = gql`
  mutation MarkAsDeleted($domain: String!, $ids: [Int!]!) {
    milestone {
      markAsDeleted(domain: $domain, ids: $ids) {
        message
        success
        code
        updatedValues {
          name
          milestone_id
          deleted
        }
      }
    }
  }
`

interface MarkMilestonesAsDeleted extends Def_MutationResponse {
  updatedValues?: MilestoneInfo[]
}

export interface MarkMilestonesAsDeletedResponse {
  milestone: {
    markAsDeleted: MarkMilestonesAsDeleted
  }
}